export default {
    ENTER:          13,
    ESC:            27,
    SPACE:          32,
    LEFT_ARROW:     37,
    UP_ARROW:       38,
	RIGHT_ARROW:    39,
    DOWN_ARROW:     40,
	A: 65,
	B: 66,
    HOTKEYS: {
        ALPHANUMERIC: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890-_'
    },
    PROPERTY_TYPE:{
        MULTI_SELECT:null,
        SINGLE_SELECT:1,
        ANY_VALUE: 0
    }
}



// WEBPACK FOOTER //
// ./modules/distribution/constants/keys.constants.js